<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'
import { EventTag } from '@/api'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Nagłówek',
              modelPath: [this, 'form', 'title'],
              multilingual: true
            }),
            new fields.ForeignKey({
              service: EventTag,
              label: 'Tagi wydarzeń',
              modelPath: [this, 'form', 'event_tags'],
              multiple: true,
              labelField: 'name',
              required: true
            })
          ]
        }
      ]
    }
  },
  data() {
    return {
      initialValues: {
        title_pl: 'Kalendarium',
        title_en: 'Calendar'
      }
    }
  }
}
</script>
